// src/api/api-handler.service.ts

import { AxiosRequestConfig, ResponseType } from 'axios';
import qs from 'qs';
import { apiProvider, apiProviderSkipGenericErrors } from './api-provider';
import { getAuthenticationHeaders, getErrorMessage } from 'src/auth/auth-helper';

interface ServiceResponse {
  isSuccess: boolean;
  data?: any;
  errorMessage?: string;
  status?: number;
  code?: string;
}


export const GET = async (
  url: string,
  params?: any,
  responseType?: ResponseType,
  headers?: any,
  skipGenericErrors: boolean = false,
  timeout?: number,
): Promise<ServiceResponse> => {
  try {
    const authHeaders = getAuthenticationHeaders();
    const config: AxiosRequestConfig = {
      params,
      paramsSerializer(input: any) {
        return qs.stringify(input, { arrayFormat: 'repeat' });
      },
      headers: headers || authHeaders,
      responseType,
      timeout: timeout,
    };

    const provider = skipGenericErrors ? apiProviderSkipGenericErrors : apiProvider;

    const response = await provider.get(url, config);

    return {
      isSuccess: true,
      data: response.data,
      status: response.status,
    };
  } catch (err: any) {
    return {
      isSuccess: false,
      errorMessage: getErrorMessage(err),
      status: err?.response?.status,
      code: err?.response?.data?.error?.code,
    };
  }
};

export const POST = async (
  url: string,
  body?: any,
  headers?: any,
  responseType?: ResponseType,
  skipGenericErrors: boolean = false,
  timeout?: number,
): Promise<ServiceResponse> => {
  try {
    const authHeaders = getAuthenticationHeaders();
    const config: AxiosRequestConfig = {
      headers: headers || authHeaders,
      responseType,
      timeout: timeout,
      // withCredentials: true,
    };

    const provider = skipGenericErrors ? apiProviderSkipGenericErrors : apiProvider;

    const response = await provider.post(url, body, config);
    return {
      isSuccess: true,
      data: response.data,
      status: response.status,
    };
  } catch (err: any) {
    return {
      isSuccess: false,
      errorMessage: getErrorMessage(err),
      status: err?.response?.status,
    };
  }
};
